import React from 'react';

const CurrentPageIdContext = React.createContext<string>('');
export default CurrentPageIdContext;
